import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedUserStateModule } from '@tix/auth/state';
import {
  AppLoaderModule,
  BtnLoadingDirectiveModule,
  HeroCheckCircle,
  HeroUpload,
  PendingChangesGuardModule,
  TixAddressAdminModule,
  TixButtonModule,
  TixCardModule,
  TixCheckboxModule,
  TixDialogModule,
  TixIconModule,
  TixIconRegistry,
  TixInputModule,
  TixPhoneNumbersAdminModule
} from '@tix/shared/ui/components';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TixAuthPagesRoutingModule } from './auth-pages-routing.module';
import { TixLoginComponent } from './login/login.component';
import { TixRegisterComponent } from './register/register.component';
import { MatIconModule } from '@angular/material/icon';
import { TixRequestPasswordResetComponent } from './request-password-reset/request-password-reset.component';
import { TixResetPasswordComponent } from './reset-password/reset-password.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RequestAccountDeletePageComponent } from './request-account-delete-page/request-account-delete-page.component';
import { LoginWithRedirectComponent } from './login-with-redirect/login-with-redirect.component';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { ReleaseSwitcherComponent } from './release-switcher/release-switcher.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TixAuthPagesRoutingModule,
    SharedUserStateModule,
    TixIconModule,
    TixCardModule,
    TixInputModule,
    TixButtonModule,
    MatFormFieldModule,
    MatInputModule,
    TixCheckboxModule,
    TixPhoneNumbersAdminModule,
    TixAddressAdminModule,
    BtnLoadingDirectiveModule,
    MatProgressSpinnerModule,
    TixDialogModule,
    PendingChangesGuardModule,
    MatIconModule,
    MatSnackBarModule,
    AppLoaderModule,
    MatRippleModule,
    MatButtonModule,
    MatSnackBarModule,
    MatTabsModule
    // BrowserAnimationsModule
  ],
  declarations: [
    TixLoginComponent,
    TixRegisterComponent,
    TixRequestPasswordResetComponent,
    TixResetPasswordComponent,
    RequestAccountDeletePageComponent,
    LoginWithRedirectComponent,
    ReleaseSwitcherComponent
  ]
})
export class TixAuthPagesModule {
  constructor(
    private iconRegistry: TixIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIcon(
      'facebook',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/images/brands/facebook.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'apple',
      sanitizer.bypassSecurityTrustResourceUrl('assets/images/brands/apple.svg')
    );
    iconRegistry.addSvgIcon(
      'google',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/images/brands/google.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'twitter',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/images/brands/twitter.svg'
      )
    );
    iconRegistry.addSvgIconConfigs([HeroUpload, HeroCheckCircle]);
  }
}
